<template>
  <b-form-group
    :label="$t('profile:preferred-language')"
    label-for="preferredLanguage"
  >
    <b-form-select id="preferredLanguage" v-model="selectedLanguage" :options="languageOptions"></b-form-select>
  </b-form-group>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      selectedLanguage: this.$store.state.language,
      languageOptions: [
        { value: 'fi', text: 'Suomi' },
        { value: 'en', text: 'English' }
      ]
    }
  },
  mounted: function () {
    this.profileUser = this.$store.state.user
  },
  methods: {
    changeLanguage (lang) {
      if (this.$i18n.i18next.language !== lang) {
        this.$store.dispatch('setTranslationsLoading', true)
        this.$i18n.i18next.changeLanguage(lang)
      }
    }
  },
  watch: {
    selectedLanguage (value) {
      this.changeLanguage(value)
    },
    language (value) {
      this.selectedLanguage = value
    }
  },
  computed: {
    ...mapGetters(['language'])
  }
}
</script>
